import axios from "./axios";

export const getBillingInfo = async (userId) => {
  return await axios.get(`/billing-info/${userId}`);
};

export const createOrUpdateBillingInfo = async (userId, data) => {
  return await axios.put(`/billing-info/${userId}`, data);
};
